module.exports = __webpack_public_path__ + "img/user.14558e71.svg";